import { render } from "./addPeriodExam.vue?vue&type=template&id=333d2d58&scoped=true"
import script from "./addPeriodExam.vue?vue&type=script&lang=js"
export * from "./addPeriodExam.vue?vue&type=script&lang=js"

import "./addPeriodExam.vue?vue&type=style&index=0&id=333d2d58&lang=scss&scoped=true"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-333d2d58"],['__file',"resources/js/pages/superAdmin/periodexam/addPeriodExam.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "333d2d58"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('333d2d58', __exports__)) {
    console.log('reload')
    api.reload('333d2d58', __exports__)
  }
  
  module.hot.accept("./addPeriodExam.vue?vue&type=template&id=333d2d58&scoped=true", () => {
    console.log('re-render')
    api.rerender('333d2d58', render)
  })

}


export default __exports__